import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { STACK_SCREEN_OPTIONS } from './screenOptions';
import { AcceptTermsScreen } from '../screens/AcceptTermsScreen';
import { TermsScreen } from '../screens/TermsScreen';
import { PrivacyScreen } from '../screens/PrivacyScreen';
import { HelpScreen } from '../screens/HelpScreen';

/** Exportée pour que la carte des liens puisse typer les adresses de cette pile (cf. liensWeb). */
export type TermsGateParamList = { AcceptTerms: undefined; Terms: undefined; Privacy: undefined; Help: undefined };
const Stack = createNativeStackNavigator<TermsGateParamList>();

// Mini-stack de l'étape obligatoire d'acceptation des CGU, pour que la case ait ses liens cliquables.
// Help y est monté aussi : ProfileNavigator, qui l'héberge d'habitude, n'existe pas pendant le gate.
export function TermsGateNavigator({ onAccepted, outdated }: { onAccepted: () => void; outdated?: boolean }) {
  return (
    <Stack.Navigator screenOptions={STACK_SCREEN_OPTIONS}>
      <Stack.Screen name="AcceptTerms">
        {({ navigation }) => (
          <AcceptTermsScreen
            onAccepted={onAccepted}
            onOpenTerms={() => navigation.navigate('Terms')}
            onOpenPrivacy={() => navigation.navigate('Privacy')}
            onOpenHelp={() => navigation.navigate('Help')}
            outdated={outdated}
          />
        )}
      </Stack.Screen>
      <Stack.Screen name="Terms">
        {({ navigation }) => (
          <TermsScreen onBack={() => navigation.goBack()} onOpenPrivacy={() => navigation.navigate('Privacy')} />
        )}
      </Stack.Screen>
      <Stack.Screen name="Privacy">
        {({ navigation }) => (
          <PrivacyScreen onBack={() => navigation.goBack()} onOpenTerms={() => navigation.navigate('Terms')} />
        )}
      </Stack.Screen>
      <Stack.Screen name="Help">
        {({ navigation }) => <HelpScreen onBack={() => navigation.goBack()} />}
      </Stack.Screen>
    </Stack.Navigator>
  );
}
